













































import { defineComponent, PropType } from "@vue/composition-api";
import { getElement } from "@/lib/elementHelpers";
import { BaseMenuItem } from "@/types";
import BaseIcon from "@/components/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";
import BaseList, { BaseListItem } from "@/components/BaseList";

export default defineComponent({
  name: "BaseMenu",
  components: { BaseIconButton, BaseListItem, BaseList, BaseIcon },
  props: {
    activatorClass: { type: String, default: "" },
    items: { type: Array as () => BaseMenuItem[] | undefined },
    position: { type: String as PropType<"left" | "right" | "center" | "bottom-center">, default: "right" },
    activeItem: { type: Object as () => BaseMenuItem | undefined },
  },
  data() {
    return {
      show: false,
      isTopPosition: false,
    };
  },
  computed: {
    hasItems(): boolean {
      return (this.items?.length ?? []) > 0;
    },
  },
  methods: {
    activator(e: Event) {
      e.stopPropagation();
      if (!this.show) {
        (getElement(this.$refs.content) as HTMLElement).style.setProperty("display", "");
        const menuContentHeight = (getElement(this.$refs.content) as HTMLElement).offsetHeight;
        const activatorPosition = (getElement(this.$refs.activator) as HTMLElement).getBoundingClientRect();
        let safeBottom = 0;

        getComputedStyle(document.documentElement)
          .getPropertyValue("--safe-bottom-position")
          .replace(/calc|px|\(|\)/g, "")
          .split("+")
          .forEach(item => (safeBottom += Number(item)));

        this.isTopPosition = Math.abs(window.innerHeight - activatorPosition.bottom) < menuContentHeight + safeBottom;
        (getElement(this.$refs.content) as HTMLElement).style.setProperty("display", "none");
      }
      this.show = !this.show;
      if (this.show) {
        this.$emit("active");
        (getElement(this.$refs.activator) as HTMLElement).focus();
      }
    },
    onFocusOut() {
      this.show = false;
    },
    onClick(item: BaseMenuItem) {
      this.$emit(`click:${item.name}`);
      this.$emit("click", item.name);
      this.show = false;
    },
  },
});
